var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "assess-left" }, [
    _c(
      "div",
      { staticClass: "el-card__header" },
      [
        _c("span", { staticClass: "pull-left" }, [_vm._v("公告类型")]),
        _vm._v(" "),
        _c(
          "el-tooltip",
          {
            attrs: {
              content: "添加公告类型",
              effect: "dark",
              placement: "top",
            },
          },
          [
            _c("span", {
              staticClass: "iconfont icontianjia pull-right pointer",
              on: { click: _vm.addCategory },
            }),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { directives: [{ name: "height", rawName: "v-height" }] },
      [
        _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
          _c(
            "ul",
            { staticClass: "assess-left-ul" },
            _vm._l(_vm.department, function (item, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: index == _vm.tabIndex ? "active" : "",
                  on: {
                    click: function ($event) {
                      return _vm.clickDepart(index, item.id)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "line1" }, [
                    _vm._v(_vm._s(item.cate_name)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-popover",
                    {
                      ref: "pop-" + item.id,
                      refInFor: true,
                      attrs: {
                        offset: 10,
                        placement: "bottom-end",
                        trigger: "click",
                      },
                      on: {
                        hide: _vm.handleHide,
                        "after-enter": function ($event) {
                          return _vm.handleShow(item.id)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "right-item-list" }, [
                        _c(
                          "div",
                          {
                            staticClass: "right-item",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.addDivsion(item.id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("public.edit")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "right-item",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleDelete(item.id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("public.delete")))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabIndex == index,
                            expression: "tabIndex == index",
                          },
                        ],
                        staticClass:
                          "icon iconfont icongengduo pointer assess-left-more",
                        attrs: { slot: "reference" },
                        slot: "reference",
                      }),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }